"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_use_1 = require("react-use");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const rootUiActions_1 = require("companion-app-components/flux/root-ui/rootUiActions");
const core_1 = require("companion-app-components/utils/core");
const inviteSent_svg_1 = __importDefault(require("assets/inviteSent.svg"));
const actions_1 = require("./actions");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const InviteSent = ({ name, datasetName }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes, cx } = useStyles();
    (0, react_use_1.useEffectOnce)(() => {
        core_1.tracker.track(core_1.tracker.events.datasetSharing, { property: 'userInvited' });
    });
    const handleClose = () => {
        dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_INVITE_SENT));
    };
    return (<Dialog_1.default open sx={{ '& .MuiPaper-root': { padding: '0 20px' } }}>
      <DialogTitle_1.default className={classes.dialogTitleWrapper}>
        <Typography_1.default variant="h6" className={classes.title}>
          Invite Sent
        </Typography_1.default>
        <Typography_1.default variant="body1" className={classes.textTertiary}>
          The invite link expires in 24 hours.
        </Typography_1.default>
      </DialogTitle_1.default>
      <IconButton_1.default aria-label="close" onClick={handleClose} className={classes.closeButton}>
        <Close_1.default fontSize="small"/>
      </IconButton_1.default>
      <DialogContent_1.default className={classes.contents}>
        <img src={inviteSent_svg_1.default} className={classes.sentImg} alt="Invite Sent"/>
        <Typography_1.default gutterBottom variant="h6" className={cx(classes.weight400, classes.title)}>
          {`${name} has been invited to ${datasetName}`}
        </Typography_1.default>
        <Typography_1.default gutterBottom variant="caption" className={classes.textTertiary}>
          {`You will be notified when ${name} accepts your invite.`} 
        </Typography_1.default>
      </DialogContent_1.default>
      <DialogActions_1.default className={classes.dialogAction}>
        <Button_1.default onClick={handleClose} variant="contained" size="small" sx={{ backgroundColor: 'action.surface' }}>
          DONE
        </Button_1.default>
      </DialogActions_1.default>
    </Dialog_1.default>);
};
exports.default = InviteSent;
